// extracted by mini-css-extract-plugin
export default {"label-value-table":"LabelValueTable_label-value-table__j7pt1"};